// Changelog aplikace – nejnovější verze nahoře.
// Při releasu přidej novou položku (verze = APP_VERSION ve version.js).
export const CHANGELOG = [
  {
    version: '2.16.3',
    date: '2026-06-21',
    changes: [
      'Mapa: checkpointy i body zájmu lze nyní umístit i přes/uvnitř zóny.',
    ],
  },
  {
    version: '2.16.2',
    date: '2026-06-21',
    changes: [
      'Mapa: spolehlivá oprava kreslení polygonu i přes/uvnitř existující zóny.',
    ],
  },
  {
    version: '2.16.1',
    date: '2026-06-21',
    changes: [
      'Mapa: lze kreslit polygon i uvnitř existující zóny.',
      'Mapa: kliknutí na zónu ukáže počet osob aktuálně v zóně.',
    ],
  },
  {
    version: '2.16.0',
    date: '2026-06-21',
    changes: [
      'Mapa MU (2. část): OpS nakreslí do mapy polygony zón a obarví je.',
      'Checkpoint lze z mapy odebrat zpět do nabídky (popup → „Odebrat z mapy“).',
    ],
  },
  {
    version: '2.15.1',
    date: '2026-06-21',
    changes: [
      'Oprava: mapový podklad (dlaždice) se teď správně načítá.',
    ],
  },
  {
    version: '2.15.0',
    date: '2026-06-21',
    changes: [
      'Mapa MU (1. část): OpS umístí na mapu checkpointy a body zájmu (název, ikona, barva).',
      'Všichni přihlášení si v sekci „Mapa MU“ zobrazí mapu MU – body, navigace, moje poloha.',
    ],
  },
  {
    version: '2.14.0',
    date: '2026-06-21',
    changes: [
      'Stránka „Nastavení“ (klik na jméno/avatar) nově sdružuje účet, vzhled i přístupnost.',
      'Vzhled: přepínání světlého/tmavého režimu přímo v Nastavení.',
      'Přístupnost: volba většího písma pro lepší čitelnost.',
    ],
  },
  {
    version: '2.13.1',
    date: '2026-06-21',
    changes: [
      'Skener QR je nově jen v hlavičce a barevně zvýrazněný (zrušena duplicita v rychlých akcích).',
      'Příchod/odchod přesunut mezi dlaždice sekce „Mimořádné události“.',
    ],
  },
  {
    version: '2.13.0',
    date: '2026-06-21',
    changes: [
      'Přehlednější rozcestník: dvě hlavní sekce – „Mimořádné události“ a „Můj spolek“ (+ Správa systému).',
      'Rychlé akce nahoře: Skenovat QR a Příchod/odchod hned po ruce.',
    ],
  },
  {
    version: '2.12.0',
    date: '2026-06-21',
    changes: [
      'Tlačítko „Skenovat QR“ je teď v hlavičce na každé stránce.',
      'Skener sám pozná typ QR – vstup do zóny vs. předání materiálu – a otevře správnou obrazovku.',
    ],
  },
  {
    version: '2.11.0',
    date: '2026-06-19',
    changes: [
      'Tato stránka „Novinky“ – přehled verzí a změn (odkaz najdete v patičce).',
    ],
  },
  {
    version: '2.10.0',
    date: '2026-06-19',
    changes: [
      'Klikací jméno/avatar v hlavičce otevře „Můj profil“.',
      'Můj profil: úprava osobních a kontaktních údajů (jméno, e-mail, telefon).',
    ],
  },
  {
    version: '2.9.0',
    date: '2026-06-19',
    changes: [
      'Schopnosti člena (PSP, KI, Technik, OpS, Gastro, Ubytovací) – výběr při registraci i v profilu.',
      'Přehled členů: sloupec schopností a filtr podle nich (i pro operační středisko).',
    ],
  },
  {
    version: '2.8.0',
    date: '2026-06-18',
    changes: [
      'Nový vzhled celé aplikace – přehlednější hlavička, dlaždice a ikony.',
    ],
  },
  {
    version: '2.7.0',
    date: '2026-06-18',
    changes: [
      'Tlačítko „Zpětná vazba“ v hlavičce pro hlášení chyb a námětů.',
    ],
  },
  {
    version: '2.6.0',
    date: '2026-06-18',
    changes: [
      'Přehledy a exporty (CSV): materiál na MU s rozbalením boxů, účastníci, časová osa příchodů/odchodů.',
    ],
  },
  {
    version: '2.5.0',
    date: '2026-06-18',
    changes: [
      'Euroboxy – předpřipravené boxy s obsahem a evidenčním číslem, naložení jedním klikem.',
      'Vyúčtování po návratu a odpisy materiálu (spotřeba, poškození, ztráta, dar).',
    ],
  },
  {
    version: '2.4.0',
    date: '2026-06-17',
    changes: [
      'Konvoje – cesta s více vozidly a vleky, náklad a řidič pro každou jednotku.',
      'Předání materiálu na MU po vozidlech i za celý konvoj.',
      'Přejmenování aplikace na TEČČKa (Technická evidence ČČKa).',
    ],
  },
];
